import React from "react";
import { withRouter, hashHistory } from "react-router";
import "./changefundlistentry.css";
import { connect } from "react-redux";
import Util from "../util.js";



class ChangeFundListEntry extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  toChangeFundList = () =>
    hashHistory.push({
      pathname: "/ChangeFundList",
      query: { superFundCode:this.props.superFundCode },
      state: {  superFundCode:this.props.superFundCode  }
    });

  render() {
    const {effectDateStr}=this.props
    return (
      <div className="Entry_container" onClick={this.toChangeFundList}>
        <span className="Entry_title">调仓记录</span>
        <div className="Entry_btn" >
        {
										Util.returnEmptyAlone(effectDateStr) === false ?
                    <span className="Entry_data">暂无调仓记录</span>
										:
                    <span className="Entry_data">截止{effectDateStr || "--"}</span>
									}
          <img style={{ width: ".2rem" }} src={require("../img/n_icon_arrow_gray@2x.png")} />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const {superFundAdjustmentVersion={}}=state.strategiesDetails
  return {
    effectDateStr:superFundAdjustmentVersion&&superFundAdjustmentVersion.effectDateStr    
  };
}
export default withRouter(connect(mapStateToProps)(ChangeFundListEntry));



// WEBPACK FOOTER //
// ./src/components/ChangeFundListEntry.js